import ADSProductSelector from "./Component/ADSProductSelector";
import styles from './ADSContentRight.module.scss'
import ADSPlayground from "./Component/ADSPlayground";

const ADSContentRight = () => {
  return (
    <div className={styles.wrapper}>
      {/* PRODUCT SELECTOR */}
      <ADSProductSelector/>

      {/*  PLAYGROUND */}
      <ADSPlayground/>
    </div>
  );
};

export default ADSContentRight;
